// auth.js
import { jwtDecode } from "jwt-decode";

/* Cache-bust: bump this string on every deployment that changes permission logic */
const PERM_CACHE_VERSION = "v3";
(function bustStaleCache() {
  if (typeof localStorage === "undefined") return;
  if (localStorage.getItem("cyt_cache_v") !== PERM_CACHE_VERSION) {
    localStorage.removeItem("cyt_permissions");
    localStorage.setItem("cyt_cache_v", PERM_CACHE_VERSION);
  }
})();

export const setToken = (token) => {
  localStorage.setItem("token", token);
};

export const getToken = () => {
  return localStorage.getItem("token");
};

export const removeToken = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("cyt_permissions");
};

export const savePermissions = (permissions) => {
  if (permissions === null || permissions === undefined) {
    localStorage.removeItem("cyt_permissions");
  } else {
    localStorage.setItem("cyt_permissions", JSON.stringify(permissions));
  }
};

/* Page-level access. A role that has any "page:<path>" key only sees the pages it was given
   (Roles page); older roles without page keys keep working by module (permKey). */
export const PAGE_PREFIX = "page:";
export const canOpenPage = (path, permKey) => {
  const decoded = getDecodedToken();
  if (!decoded || decoded.role !== 2) return false;
  if (!decoded.roleId) return true;
  let perms = [];
  try { perms = JSON.parse(localStorage.getItem("cyt_permissions") || "[]") || []; } catch { perms = []; }
  if (!Array.isArray(perms)) return false;
  if (perms.some((x) => String(x).startsWith(PAGE_PREFIX))) return perms.includes(PAGE_PREFIX + path);
  return !permKey || perms.includes(permKey);
};

export const hasPermission = (key) => {
  const decoded = getDecodedToken();
  if (!decoded || decoded.role !== 2) return false;
  if (!decoded.roleId) return true;
  const raw = localStorage.getItem("cyt_permissions");
  if (!raw) return false; // permissions not loaded → deny access (fail closed)
  const perms = JSON.parse(raw);
  return Array.isArray(perms) && perms.includes(key);
};

// Super Admin = an admin with no Role. Team members (with a Role) never see revenue figures — the API
// strips them too, this just keeps the screens from showing empty "₹0" placeholders.
export const isSuperAdmin = () => {
  try { const d = getDecodedToken(); return !!d && d.role === 2 && !d.roleId; } catch { return false; }
};

export const getDecodedToken = () => {
  const token = getToken();
  if (!token) return null;
  return jwtDecode(token);
};

export const isAuthenticated = () => {
  const token = getToken();
  if (!token) return false;

  try {
    const { exp } = jwtDecode(token);
    if (Date.now() >= exp * 1000) {
      removeToken();
      return false;
    }
    return true;
  } catch (error) {
    return false;
  }
};
